import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'catalogFiltersOpen'
const DESKTOP_BREAKPOINT = 1024

// Mobile filter panel: fullscreen overlay toggled by the "Фильтры" button.
// The panel is re-rendered on every turbo-frame filter submit, so the open
// state is persisted in sessionStorage and restored on connect.
export default class extends Controller {
  static targets = ['panel']

  connect() {
    if (window.innerWidth >= DESKTOP_BREAKPOINT) return
    if (sessionStorage.getItem(STORAGE_KEY) === '1') this.open()
  }

  disconnect() {
    document.body.classList.remove('overflow-hidden')
  }

  open() {
    this.panelTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    sessionStorage.setItem(STORAGE_KEY, '1')
  }

  close() {
    this.panelTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
    sessionStorage.setItem(STORAGE_KEY, '0')
  }
}
